import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) { 
    return { error }; 
  }

  componentDidCatch(error, info) { 
    console.error("[ErrorBoundary]", error, info); 
  }

  render() {
    if (this.state.error) {
      return (
        <div className="card-skin">
          <h3 className="card-title-skin">Something went wrong</h3>
          <pre className="text-white/80 text-xs overflow-auto max-h-64">
            {String(this.state.error)}
            {this.state.error.stack && '\n\nStack:\n' + this.state.error.stack}
          </pre>
          <button 
            className="mt-4 px-4 py-2 bg-gold text-navy rounded"
            onClick={() => this.setState({ error: null })}
          >
            Try Again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
